import { useEffect, useState } from "react";
import "../styles/AssignDoctorModal.css";
const BASE_URL = process.env.REACT_APP_API_BASE_URL;
export default function AssignDoctorModal({ patient, onClose, onAssigned }) {
  const [doctors, setDoctors] = useState([]);
  const [doctorId, setDoctorId] = useState("");
  const [loading, setLoading] = useState(false);
  const [currentDoctor, setCurrentDoctor] = useState("");

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem("user"));
    let url = `${BASE_URL}/api/doctors/`;
    if (user.role === "assigner") {
      url += `?assigner_id=${user.id}`;
    } else if (user.role === "center") {
      url += `?center_id=${user.center_id}`;
    } else {
      console.error("Invalid user role");
      return;
    }
  
    fetch(url)
      .then(async (res) => {
        const text = await res.text();
        if (!res.ok) {
          throw new Error(text);
        }
        return JSON.parse(text);
      })
      .then((data) => {
        setDoctors(data);
        if (patient.assigned && patient.assigned !== "") {
          setCurrentDoctor(patient.assigned);
          const currentDoc = data.find(
            (doc) => doc.doctor_name === patient.assigned
          );
          if (currentDoc) {
            setDoctorId(currentDoc.id);
          }
        }
      })
      .catch((err) => {
        console.error("Error fetching doctors:", err);
      });
  }, [patient.assigned]);

  const assignDoctor = async () => {
    if (!doctorId) return;
    setLoading(true);
    try {
      const response = await fetch(`${BASE_URL}/api/assign-doctor/`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          study_id: patient.study_id,
          doctor_id: doctorId,
        }),
      });
      const data = await response.json();
      if (response.ok) {
        const message = data.old_doctor 
          ? `Doctor reassigned from ${data.old_doctor} to ${data.new_doctor}`
          : `Doctor ${data.new_doctor} assigned successfully`;
        alert(message);
        if (onAssigned) {
          onAssigned();
        }
        onClose();
      } else {
        alert(data.error || "Failed to assign doctor");
      }
    } catch (err) {
      console.error("Error assigning doctor:", err);
      alert("An error occurred while assigning the doctor");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="am-overlay" onClick={(e) => e.target === e.currentTarget && onClose()}>
      <div className="am-box" role="dialog" aria-modal="true" aria-labelledby="am-title">
        <div className="am-header">
          <div className="am-title-row">
            <div className="am-icon-wrap">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round">
                <path d="M8 20v-3a4 4 0 0 1 8 0v3" />
                <circle cx="12" cy="10" r="3" />
                <path d="M19 9a7 7 0 1 0-13.6 2.3" />
                <path d="M19 15v3m0 3v.01" />
              </svg>
            </div>
            <h2 className="am-title" id="am-title">
              {currentDoctor ? "Reassign Doctor" : "Assign Doctor"}
            </h2>
          </div>
          <button className="am-close-btn" onClick={onClose} aria-label="Close">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
              <path d="M18 6 6 18M6 6l12 12" />
            </svg>
          </button>
        </div>

        <p className="am-subtitle">
          {currentDoctor 
            ? `Current doctor: ${currentDoctor}. Select a new doctor to reassign.`
            : "Select a doctor to assign for this study."}
        </p>
        <hr className="am-divider" />

        <label className="am-label" htmlFor="am-doctor-select">Doctor</label>
        <select
          id="am-doctor-select"
          className="am-select"
          value={doctorId}
          onChange={(e) => setDoctorId(e.target.value)}
        >
          <option value="">— Select a doctor —</option>
          {doctors.map((doc) => (
            <option key={doc.id} value={doc.id}>
              {doc.doctor_name} {currentDoctor === doc.doctor_name ? "(Current)" : ""}
            </option>
          ))}
        </select>

        <div className="am-footer">
          <button className="am-btn-cancel" onClick={onClose} disabled={loading}>
            Cancel
          </button>
          <button
            className="am-btn-assign"
            onClick={assignDoctor}
            disabled={!doctorId || loading || (currentDoctor === doctors.find(d => d.id === doctorId)?.doctor_name)}
          >
            {loading && <span className="am-spinner" />}
            {loading ? "Assigning…" : (currentDoctor ? "Reassign" : "Assign")}
          </button>
        </div>
      </div>
    </div>
  );
}